import React from 'react';

export const DisclosureIcon:React.FC<React.SVGProps<SVGSVGElement>> = ({ width = 26, height = 26, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M7.79934 11.0498L12.9985 16.2498L18.1993 11.0498"
        stroke="#458FFF"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="0.65"
        y="-0.65"
        width="24.7014"
        height="24.7"
        rx="12.35"
        transform="matrix(1 0 0 -1 -0.00134277 24.7)"
        stroke="#458FFF"
        strokeWidth="1.3"
      />
    </svg>

  );
};